/* JUGO BYOB v2 — bundle builder logic.
   Configured by the section: window.JugoByobConfig is set on the page
   before this script runs. It includes per-product variant IDs (real
   Shopify), an optional sellingPlanId for the "Subscribe" mode, and
   optional configurable gift tiers and discount percentages.
   Cart writes go to Shopify's storefront /cart/add.js endpoint. */
(function () {
  'use strict';
  var ROOT = document.querySelector('.jugo-byob-v2');
  if (!ROOT) return;

  var CFG = window.JugoByobConfig || {};

  // GIFTS source-of-truth — render hint text from this, not the DOM
  var GIFTS = (CFG.gifts && CFG.gifts.length) ? CFG.gifts : [
    { tier: 2, name: 'freshener' },
    { tier: 4, name: 'tote' },
    { tier: 6, name: 'hat' }
  ];

  // PRODUCTS — populated from CFG.products keyed by builder ID (energy/focus/etc.).
  // Each entry must have: variantId, price, img, name, sellingPlanId (optional).
  var PRODUCTS = CFG.products || {};

  // Stacked discounts (multiplicative):
  //   Bundle tier:  10% at 2 jars  ·  12.5% at 4  ·  15% at 6
  //   Subscription: flat 15%
  // (Welcome offer retired — first order now prices the same as renewals.)
  var BYOB_DISCOUNT = CFG.bundleDiscount || { 1: 0, 2: 0.10, 3: 0.10, 4: 0.125, 5: 0.125, 6: 0.15 };
  var SUB_DISCOUNT = (typeof CFG.subDiscount === 'number') ? CFG.subDiscount : 0.15;
  var WELCOME_DISCOUNT = (typeof CFG.welcomeDiscount === 'number') ? CFG.welcomeDiscount : 0;

  var cart = {};
  var isSubscribing = true;
  var isAdding = false;
  var prevState = {};

  function $(sel, ctx) { return (ctx || ROOT).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || ROOT).querySelectorAll(sel)); }

  // Gift-unlock celebration — a confetti burst at the unlocked gift cell.
  // Appended to <body> with fixed positioning so nothing clips it.
  var CONFETTI_COLORS = ['#f8b036', '#05be50', '#fe5a40', '#396fd8', '#f9c033', '#ffffff'];
  function celebrate(cell) {
    if (!cell || typeof cell.getBoundingClientRect !== 'function') return;
    var r = cell.getBoundingClientRect();
    if (!r.width) return;
    var layer = document.createElement('div');
    layer.className = 'jugo-confetti-layer';
    layer.style.left = (r.left + r.width / 2) + 'px';
    layer.style.top = (r.top + r.height / 2) + 'px';
    for (var i = 0; i < 22; i++) {
      var p = document.createElement('span');
      var ang = (Math.PI * 2 * i) / 22 + (Math.random() - 0.5) * 0.5;
      var dist = 70 + Math.random() * 90;
      p.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      p.style.setProperty('--dx', (Math.cos(ang) * dist).toFixed(1) + 'px');
      p.style.setProperty('--dy', (Math.sin(ang) * dist - 18).toFixed(1) + 'px');
      p.style.setProperty('--rot', ((Math.random() - 0.5) * 540).toFixed(0) + 'deg');
      p.style.animationDelay = (Math.random() * 70).toFixed(0) + 'ms';
      layer.appendChild(p);
    }
    document.body.appendChild(layer);
    setTimeout(function () { layer.remove(); }, 1300);
  }

  function totalQty() { return Object.values(cart).reduce(function (a, b) { return a + b; }, 0); }
  function fmt(n) { return '$' + n.toFixed(2); }
  function fmtShort(n) { return '$' + Math.round(n); }

  function avgPrice() {
    var n = totalQty();
    if (n === 0) return 19.0;
    var s = 0;
    Object.keys(cart).forEach(function (id) {
      var p = PRODUCTS[id]; if (!p) return;
      s += p.price * cart[id];
    });
    return s / n;
  }

  function tierPct(n) {
    if (n < 1) return 0;
    var key = Math.min(n, 6);
    return key in BYOB_DISCOUNT ? BYOB_DISCOUNT[key] : BYOB_DISCOUNT[6];
  }

  function priceWith(subtotal, n) {
    var total = subtotal * (1 - tierPct(n));
    if (isSubscribing && n > 0) total *= (1 - SUB_DISCOUNT);
    return total;
  }

  function savingsAt(n) {
    if (n <= 0) return 0;
    var p = avgPrice();
    var subtotal = n * p;
    return subtotal - priceWith(subtotal, n);
  }

  function compute() {
    var n = totalQty();
    var subtotal = 0;
    Object.keys(cart).forEach(function (id) {
      var p = PRODUCTS[id]; if (!p) return;
      subtotal += p.price * cart[id];
    });
    var total = priceWith(subtotal, n);
    return { n: n, subtotal: subtotal, total: total, savings: subtotal - total };
  }

  // Per-jar display: cascade-aware — show the per-jar price the customer
  // would pay AT THE NEXT STACK LEVEL (i.e. if they add this jar).
  function perJarDisplay(retail) {
    var nextN = Math.min(totalQty() + 1, 6);
    var p = retail * (1 - tierPct(nextN));
    if (isSubscribing) p *= (1 - SUB_DISCOUNT);
    return p;
  }
  function renewalPerJar(retail) {
    var nextN = Math.min(totalQty() + 1, 6);
    var p = retail * (1 - tierPct(nextN));
    if (isSubscribing) p *= (1 - SUB_DISCOUNT);
    return p;
  }

  // Per-jar price the customer ACTUALLY pays at a given stack size (present-tense,
  // not forward-looking). At 0 jars we show the single-jar starting price.
  function perJarAt(retail, n) {
    var k = Math.min(Math.max(n, 1), 6);
    var p = retail * (1 - tierPct(k));
    if (isSubscribing) p *= (1 - SUB_DISCOUNT);
    return p;
  }
  // Next bundle-discount threshold above the current stack (where price drops).
  function nextThreshold(n) {
    var TH = [2, 4, 6];
    for (var i = 0; i < TH.length; i++) { if (TH[i] > n) return TH[i]; }
    return null;
  }

  function updateCardPrices() {
    var n = totalQty();
    var nt = nextThreshold(n);
    $all('.tile').forEach(function (tile) {
      var el = tile.querySelector('.tile__price');
      if (!el) return;
      var one = parseFloat(el.getAttribute('data-one'));
      var now = perJarAt(one, n);
      var strike = el.querySelector('.strike');
      var num = el.querySelector('.price-num');
      var plabel = el.querySelector('.tile__plabel');
      var next = el.querySelector('.tile__next');
      if (num) num.textContent = '$' + now.toFixed(2);
      // Only show the strikethrough when there's a REAL discount.
      if (strike) {
        strike.textContent = '$' + one.toFixed(2);
        strike.style.display = (one - now > 0.005) ? '' : 'none';
      }
      // Label that names what the price IS — your blended per-jar in this box.
      if (plabel) plabel.textContent = n >= 1 ? ('in your ' + n + '-jar box') : '';
      // Carrot: what one (or a couple) more jars drops the per-jar price to.
      if (next) {
        if (n >= 6) {
          next.textContent = 'lowest price ✓';
          next.style.display = '';
        } else if (n >= 1 && nt) {
          var y = perJarAt(one, nt);
          var add = nt - n;
          next.textContent = 'add ' + add + ' → $' + y.toFixed(2) + '/jar';
          next.style.display = (now - y > 0.005) ? '' : 'none';
        } else {
          next.textContent = 'stack to save more';
          next.style.display = '';
        }
      }
      tile.classList.toggle('is-onetime', !isSubscribing);
    });
  }

  function setMode(sub) {
    isSubscribing = sub;
    // One-time mode flags the root so the cart CTA turns yellow (matches the
    // one-time = yellow convention used on the product cards).
    if (ROOT) ROOT.classList.toggle('is-onetime-mode', !sub);
    // Keep every toggle instance (builder header, repeat below grid, cart bar) in sync.
    $all('[data-mode]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-mode') === (sub ? 'sub' : 'once'));
    });
    updateCardPrices();
    render();
  }

  function addProduct(id) {
    if (!PRODUCTS[id]) return;
    cart[id] = (cart[id] || 0) + 1;
    render();
  }
  function decProduct(id) {
    if (!cart[id]) return;
    cart[id] -= 1;
    if (cart[id] <= 0) delete cart[id];
    render();
  }

  function render() {
    var t = compute();
    var nextGift = GIFTS.find(function (g) { return t.n < g.tier; });

    updateCardPrices();

    var tkEy = $('#jugoByobTkEyebrow');
    var tkAmt = $('#jugoByobTkAmount');
    if (tkEy && tkAmt) {
      if (t.n === 0) {
        tkEy.textContent = 'Save up to';
        tkAmt.textContent = '28%';
      } else {
        tkEy.textContent = "You're saving";
        tkAmt.textContent = fmtShort(t.savings) + '!';
      }
    }

    GIFTS.forEach(function (g) {
      var cell = $('#jugoByobTkGift' + g.tier);
      if (!cell) return;
      var hint = cell.querySelector('[data-hint="' + g.tier + '"]');
      var state = t.n >= g.tier ? 'unlocked'
        : (nextGift && nextGift.tier === g.tier) ? 'next'
          : 'locked';
      cell.setAttribute('data-state', state);
      if (hint) {
        if (state === 'unlocked') hint.textContent = 'Unlocked';
        else if (state === 'next') {
          var r = g.tier - t.n;
          hint.textContent = r === 1 ? 'Add 1 more' : ('Add ' + r + ' more');
        } else {
          hint.textContent = 'At ' + g.tier + ' jars';
        }
      }
      if (prevState[g.tier] !== 'unlocked' && state === 'unlocked') {
        cell.classList.remove('just-unlocked');
        // eslint-disable-next-line no-unused-expressions
        cell.offsetWidth;
        cell.classList.add('just-unlocked');
        celebrate(cell);
      }
      prevState[g.tier] = state;
    });

    var nudge = $('#jugoByobTkNudge');
    if (nudge) {
      nudge.classList.remove('is-max');
      if (t.n === 0) {
        nudge.innerHTML = '<strong>Stack 6 jars</strong> &rarr; 3 free gifts + up to 28% off';
      } else if (t.n >= 6) {
        nudge.classList.add('is-max');
        nudge.innerHTML = '<strong>&#10003; All 3 gifts unlocked</strong> &middot; you&rsquo;re saving ' + fmtShort(t.savings);
      } else if (nextGift) {
        var rem = nextGift.tier - t.n;
        if (rem === 1) {
          nudge.innerHTML = 'Add <strong>1 more jar</strong> to unlock your free ' + nextGift.name;
        } else {
          nudge.innerHTML = 'Add <strong>' + rem + ' more jars</strong> to unlock the ' + nextGift.name;
        }
      }
    }

    Object.keys(PRODUCTS).forEach(function (id) {
      var q = cart[id] || 0;
      var tile = ROOT.querySelector('.tile[data-id="' + id + '"]');
      var num = ROOT.querySelector('[data-qty-for="' + id + '"]');
      if (tile) tile.classList.toggle('is-selected', q > 0);
      if (num) num.textContent = q;
    });

    var bar = $('#jugoByobCartbar');
    var cnt = $('#jugoByobCbCount');
    var lbl = $('#jugoByobCbCountLabel');
    var tot = $('#jugoByobCbTotal');
    var strike = $('#jugoByobCbStrike');
    var save = $('#jugoByobCbSave');
    var tick = $('#jugoByobCbTick');
    if (cnt) cnt.textContent = t.n;
    if (lbl) lbl.innerHTML = t.n === 1 ? 'jar<br>in stack' : 'jars<br>in stack';
    var allUnlocked = t.n >= GIFTS[GIFTS.length - 1].tier;
    if (tick) tick.classList.toggle('is-on', allUnlocked);
    if (tot) tot.textContent = fmt(t.total);
    if (strike) strike.textContent = t.savings > 0.5 ? fmt(t.subtotal) : '';
    var pct = t.subtotal > 0 ? Math.round((t.savings / t.subtotal) * 100) : 0;
    if (save) save.textContent = pct > 0 ? ('save ' + pct + '%') : '';

    var items = $('#jugoByobCbItems');
    if (items) {
      items.innerHTML = '';
      var flat = [];
      Object.keys(cart).forEach(function (id) { for (var i = 0; i < cart[id]; i++) flat.push(id); });
      var VISIBLE = 4;
      flat.slice(0, VISIBLE).forEach(function (id) {
        var p = PRODUCTS[id]; if (!p) return;
        var img = document.createElement('img');
        img.src = p.img;
        img.alt = p.name;
        items.appendChild(img);
      });
      if (flat.length > VISIBLE) {
        var more = document.createElement('span');
        more.className = 'cb-more';
        more.textContent = '+' + (flat.length - VISIBLE);
        items.appendChild(more);
      }
    }

    var ctaText = $('#jugoByobCbCtaText');
    if (ctaText) ctaText.textContent = isAdding ? 'Adding…' : (isSubscribing ? 'Subscribe' : 'Checkout');

    if (bar) {
      var on = t.n > 0;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('jugo-byob-v2--cart-on', on);
    }
  }

  function toggleFaq(btn) { btn.closest('.faq-item').classList.toggle('open'); }

  // Build a list of {id, quantity, selling_plan?} from cart, then POST in one go.
  function addBundleToCart() {
    if (isAdding) return;
    var t = compute();
    if (t.n <= 0) return;
    var items = [];
    Object.keys(cart).forEach(function (id) {
      var p = PRODUCTS[id]; if (!p) return;
      if (!p.variantId) {
        console.warn('[JUGO BYOB] Missing variantId for product id:', id);
        return;
      }
      var item = { id: p.variantId, quantity: cart[id] };
      if (isSubscribing && p.sellingPlanId) item.selling_plan = p.sellingPlanId;
      items.push(item);
    });
    if (!items.length) {
      window.location.href = CFG.cartUrl || '/cart';
      return;
    }
    isAdding = true;
    var cta = $('#jugoByobCbCta');
    if (cta) cta.disabled = true;
    render();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add failed: ' + r.status);
      return r.json();
    }).then(function () {
      isAdding = false;
      if (cta) cta.disabled = false;
      // Desktop: the global slide-out cart drawer opens itself (its fetch wrapper catches /cart/add) —
      // do NOT navigate to the full /cart page (which then bounces to the homepage). Mobile keeps /cart.
      if (!(window.matchMedia && window.matchMedia('(min-width: 990px)').matches)) {
        window.location.href = CFG.cartUrl || '/cart';
        return;
      }
      // Desktop stays on the page, so reset the builder to empty — building again starts
      // fresh instead of silently re-adding the same bundle on the next click.
      cart = {};
      prevState = {};
      render();
    }).catch(function (err) {
      console.error('[JUGO BYOB] Add to cart failed:', err);
      isAdding = false;
      if (cta) cta.disabled = false;
      render();
      alert("Couldn't add the bundle to your cart. Please try again.");
    });
  }

  // Wire up event delegation
  function init() {
    // Tiles click to add
    $all('.tile').forEach(function (tile) {
      var id = tile.getAttribute('data-id');
      if (!id) return;
      tile.addEventListener('click', function (e) {
        if (e.target.closest('.tile__stepper') || e.target.closest('.tile__add')) return;
        addProduct(id);
      });
      var addBtn = tile.querySelector('.tile__add');
      if (addBtn) addBtn.addEventListener('click', function (e) { e.stopPropagation(); addProduct(id); });
      var stepper = tile.querySelector('.tile__stepper');
      if (stepper) {
        var btns = stepper.querySelectorAll('button');
        if (btns[0]) btns[0].addEventListener('click', function (e) { e.stopPropagation(); decProduct(id); });
        if (btns[1]) btns[1].addEventListener('click', function (e) { e.stopPropagation(); addProduct(id); });
      }
    });

    // Mode toggles — any number of instances, all kept in sync via [data-mode].
    $all('[data-mode]').forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.getAttribute('data-mode') === 'sub'); });
    });

    // FAQ accordions
    $all('.faq-q').forEach(function (q) { q.addEventListener('click', function () { toggleFaq(q); }); });

    // Sticky CTA
    var cta = $('#jugoByobCbCta');
    if (cta) cta.addEventListener('click', addBundleToCart);

    // Hero CTA scroll-to-builder (anchor handled by browser; smooth scroll via CSS)
    setMode(true);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
